import React, { useContext, useEffect, useState } from "react";
import StatCards from "./statCards";
import { useNavigate, useParams } from "react-router";
import { Button } from "rizzui/button";
import cn from "../../../lib/utils/class-name";
import { orderData } from "../../leads";
import { basicColumns } from "../../leads/column";
import { MajorColumns } from "../../calls/column";
import CirclePause from "../../../assets/circlePause";
import { ActionIcon } from "rizzui/action-icon";
import CircleStop from "../../../assets/circleStop";
import Table from "../../../component/table";
import {
  useCampaignAnalytics,
  useSingleCampaign,
  useSingleCampaignCall,
  useSingleCampaignLead,
} from "../../../hooks/useCampaign";
import { AuthContext } from "../../../context/authContext";
import { useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { baseUrl } from "../../account/login";
import { useNotifcication } from "../../../hooks/useNotification";
import CirclePlay from "../../../assets/circlePlay";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { Text } from "rizzui/typography";
import RightDrawer from "../../../layout/appLayout/rightDrawer";
import { useDrawer } from "../../../hooks/useDrawer";
import { useModal } from "../../../hooks/useModal";
import DontEnable from "../../../component/dontEnable";
import StopCampaign from "../../../component/stopCampaign";
import { Popover } from "rizzui/popover";
import ImportFile from "../../../component/cards/importFile";
import SingleEntry from "../../../component/singleEntry";
import Add from "../../../assets/add";
import CallDrawer from "../../../component/callDrawer";

export default function ProjectDetails() {
  let { id } = useParams();
  const [currentTable, setCurrentTable] = useState("leads");
  const { data, error, isLoading } = useSingleCampaign({ id });
  const {
    data: callData,
    error: callError,
    isLoading: callLoading,
  } = useSingleCampaignCall({ id });

  const {
    data: leadData,
    error: leadError,
    isLoading: leadLoading,
  } = useSingleCampaignLead({ id });

  const {
    data: analyticsData,
    error: analyticsError,
    isLoading: analyticsLoading,
  } = useCampaignAnalytics({ id });

  const { token } = useContext(AuthContext);
  const AuthStr = `Bearer ${token}`;
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [disabled, setDisabled] = useState(false);
  const { openNotification } = useNotifcication();

  useEffect(() => {
    document.title = data?.campaign_name ?? "";
  }, [data]);

  const { openDrawer, closeDrawer } = useDrawer();

  const pauseResumeCampaign = () => {
    const uri = data?.is_paused ? "resume_campaign" : "pause_campaign";
    const id = data?._id;
    if (id && uri) {
      setDisabled(true);
      axios
        .put(
          `${baseUrl}/campaigns/${uri}/${id}`,
          { id },
          { headers: { Authorization: AuthStr } }
        )
        .then((response) => {
          console.log(response);
          const data = response.data;
          if (response?.status === 201) {
            queryClient.invalidateQueries({ queryKey: [id, token] });
            openNotification({
              status: "success",
              message:
                uri === "pause_campaign"
                  ? "Campaign Paused"
                  : "Campaign Resumed",
            });
            setDisabled(false);
          }
        })
        .catch((e) => {
          if (e?.response?.data?.message === "Session expired")
            navigate("/account/logout");
          else
            openNotification({
              status: "error",
              message: "Something went wrong",
            });
          setDisabled(false);
        });
    }
  };

  const { openModal } = useModal();

  return (
    <div>
      <div className="flex xl:hidden gap-[24px] px-2 items-center">
        <ActionIcon
          className="group !bg-transparent size-[30px] !p-0 hover:!bg-btn rounded-full"
          onClick={() => navigate("/campaigns")}
        >
          <MdOutlineKeyboardBackspace
            size={20}
            className="text-primary-dark group-hover:text-background"
          />
        </ActionIcon>
        <div>
          <Text className="font-[600] text-[18px] md:text-[24px] text-primary-dark font-ibmPlexSerif">
            {data?.campaign_name}
          </Text>
          <Text className="text-[#758599] font-switzer text-[12px] font-[400]">
            {data?.campaign_description}
          </Text>
        </div>
      </div>
      <StatCards
        className="grid md:grid-cols-2 lg:grid-cols-4 grid-flow-row my-[36px]"
        data={analyticsData?.data}
      />
      <div className="flex justify-between gap-[28px] flex-wrap items-center h-[fit] mb-[32px] ">
        <div className="flex border-[.5px] border-muted rounded-[4px] w-[244px] h-[35px] justify-center gap-[4px] place-items-center">
          <Button
            variant="text"
            className={cn(
              `h-[27px] w-[116px] rounded-[2px] font-switzer text-[14px] leading-[18.48px]`,
              currentTable === "leads"
                ? "bg-[#F2F2F2] dark:bg-btn text-[#191919] font-[500] hover:bg-[#F2F2F2] hover:dark:bg-btn hover:text-[#191919]"
                : " text-[#758599] hover:text-[#758599] font-[400]"
            )}
            onClick={() => setCurrentTable("leads")}
          >
            Contacts
          </Button>

          <Button
            variant="text"
            className={cn(
              `h-[27px] w-[116px] rounded-[2px] font-switzer text-[14px] leading-[18.48px]`,
              currentTable === "calls"
                ? "bg-[#F2F2F2] dark:bg-btn text-[#191919] font-[500] hover:bg-[#F2F2F2] hover:dark:bg-btn hover:text-[#191919]"
                : " text-[#758599] hover:text-[#758599] font-[400]"
            )}
            onClick={() => setCurrentTable("calls")}
          >
            Calls
          </Button>
        </div>
        {!isLoading && (
          <div
            className={cn(
              "flex md:min-w-[290px] h-[24px] justify-between items-center"
            )}
          >
            {data?.is_paused ? (
              <ActionIcon
                className="font-switzer min-w-[140px] w-auto !p-0 !m-0 !text-primary-dark dark:!text-[#758599] !bg-transparent font-[500] text-[14px] flex gap-[7px] items-center"
                onClick={pauseResumeCampaign}
                disabled={disabled}
              >
                <CirclePlay />
                Resume campaign
              </ActionIcon>
            ) : (
              <ActionIcon
                className="font-switzer w-[140px] !p-0 !m-0 !text-primary-dark dark:!text-[#758599] !bg-transparent font-[500] text-[14px] flex gap-[7px] items-center"
                onClick={pauseResumeCampaign}
                disabled={disabled}
              >
                <CirclePause />
                Pause campaign
              </ActionIcon>
            )}

            <Popover>
              <Popover.Trigger>
                <ActionIcon
                  variant="text"
                  className="h-[34px] w-[130px] rounded-[4px] border-[.5px] border-muted py-[10px] px-[16px] gap-[4px] bg-btn hover:text-background text-background"
                >
                  <Add className={"text-primary-dark"} />
                  <Text className="font-[400] font-gilroyMedium text-[12px] leading-[14.56px]">
                    Add contacts
                  </Text>
                </ActionIcon>
              </Popover.Trigger>

              <Popover.Content className="p-0 dark:bg-[#191919] [&>svg]:dark:fill-[#191919]">
                <div className="bg-background w-[220px] rounded-[8px] p-[8px]">
                  <Button
                    onClick={() =>
                      openModal({
                        view: <ImportFile page="leads" type="csv" id={id} />,
                      })
                    }
                    variant="text"
                    className="text-primary-dark p-[16px] h-[44px] font-switzer text-[14px] font-[400] leading-[22px] bg-inherit hover:dark:!bg-[#303236] hover:bg-gray-100 w-full justify-start"
                  >
                    Via csv
                  </Button>
                  <Button
                    onClick={() => openModal({ view: <SingleEntry id={id} /> })}
                    variant="text"
                    className="text-primary-dark p-[16px] h-[44px] font-switzer text-[14px] font-[400] leading-[22px] bg-inherit hover:dark:!bg-[#303236] hover:bg-gray-100 w-full justify-start"
                  >
                    Single entry
                  </Button>
                </div>
              </Popover.Content>
            </Popover>
          </div>
        )}
      </div>

      {currentTable === "leads" && (
        <Table
          data={leadData?.data ?? []}
          columns={basicColumns}
          pageSize={undefined}
          setPage={() => {}}
          isLoading={false}
          error={leadError}
          defaultSort={{ id: "dateandtime", desc: true }}
          meta={(row) => {
            openDrawer({
              view: (
                <RightDrawer
                  row={row}
                  onClose={closeDrawer}
                  location={"leads"}
                />
              ),
              placement: "right",
              containerClassName: "w-full md:!w-[435px]",
            });
          }}
        />
      )}
      {currentTable === "calls" && (
        <Table
          data={callData?.data ?? []}
          isLoading={callLoading}
          columns={MajorColumns()}
          pageSize={undefined}
          setPage={() => {}}
          error={callError}
          defaultSort={{ id: "dateTime", desc: true }}
          meta={(row) => {
            openDrawer({
              view: <CallDrawer row={row} />,
              placement: "right",
              containerClassName: "w-full md:!w-[435px]",
            });
          }}
        />
      )}
    </div>
  );
}
